import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import { useEffect } from "react";
import FormRow from "components/form/FormRow";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import Insumo from "entity/Insumo";
import ADC from "..";
import SelectInput from "components/form/input/SelectInput";
import { useForm } from "react-final-form";
import Operador from "entity/Operador";

export default function EditFields({ visita, TipoClass }) {
    console.log("visita", visita.data);
    const [tipo] = useTipoApontamento();
    const params = visita.cliente.getParams(ADC, tipo, TipoClass);

    const [apontamento, setApontamento] = useFieldValue();
    const form = useForm();

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = ADC.calcConformidade(apontamento, params, setApontamento);
            // form.change("conformidade", ADC.calcConformidade(apontamento, params))
            form.change("coletas", apontamento.coletas);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, params]);

    return (
        <>
            <ApontamentoCommonFields visita={visita} TipoClass={TipoClass} showVariedade />

            <ApontamentoAmostraParams>
                <FormRow>
                    <EntitySearchInput name="insumo" label="Insumo" EntityClass={Insumo} />
                </FormRow>

                <FormRow>
                    <TextInput type="number" name="dosagemRecomendada" label="Dosagem Recomendada" />
                </FormRow>
                <FormRow>
                    <EntitySearchInput
                        name="operador"
                        label="Operador"
                        EntityClass={Operador}
                        extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)}
                    />
                </FormRow>
                <FormRow>
                    <SelectInput name="turno" label="Turno" options={["A", "B", "C"]} required />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="I. A.:">
                            ({params.intervaloMin}, {params.intervaloMax})
                        </ApontamentoParamItem>
                        <ApontamentoParamItem label="M. L. A.:">{params.metrosLinearesAmostra}</ApontamentoParamItem>
                        <ApontamentoParamItem label="M. L. H.:">{params.metrosLinearesHectare}</ApontamentoParamItem>
                        <ApontamentoParamItem label="Meta (%):">{params.meta}</ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita}>
                <TextInput type="number" name="pesagem" label="Pesagem" />
            </ApontamentoColetas>

            <ApontamentoResultado>
                <FormRow>
                    <TextInput name="afericao" label="Aferição" disabled />
                </FormRow>
                <FormRow>
                    <TextInput name="media" label="Média" disabled />
                </FormRow>
                <FormRow>
                    <TextInput name="doseMetro" label="Dose por Metro" disabled />
                </FormRow>
            </ApontamentoResultado>

            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
